import { render } from "./NewProfiles.vue?vue&type=template&id=2ed33650&scoped=true"
import script from "./NewProfiles.vue?vue&type=script&lang=js"
export * from "./NewProfiles.vue?vue&type=script&lang=js"

import "./NewProfiles.vue?vue&type=style&index=0&id=2ed33650&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed33650"]])

export default __exports__